// src/utils/email.js
// Utility to send email using EmailJS
import emailjs from 'emailjs-com';

const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const userID = process.env.REACT_APP_EMAILJS_USER_ID;

export const sendDemoEnquiry = async ({ name, company, contact, message }) => {
  const templateParams = {
    name,
    company,
    contact,
    message,
    to_email: 'sales@indelect.com',
    subject: 'Web Enquiry',
  };

  return emailjs.send(serviceID, templateID, templateParams, userID);
};
